import { Skeleton, Stack, Table, type TableProps } from "@mantine/core"
import { AnimatePresence, motion } from "framer-motion"
import type { ReactNode } from "react"
import type { TUser } from "@/types"
import { buildUserURL, UserContext } from "@/utils"
import { AppTable } from "../utils"
import { UserLine } from "./UserLine"

interface IProps extends TableProps {
  users: TUser[]
  loading?: boolean
  headers?: ReactNode[]
  withLink?: boolean
}

export function UsersTable({ users, headers, children, loading, withLink }: IProps) {
  // biome-ignore-start lint/suspicious/noArrayIndexKey: reason
  return (
    <AppTable>
      {headers && (
        <Table.Thead>
          <Table.Tr>
            {headers?.map((header, index) => (
              <Table.Th key={index} ta="right">
                {header}
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
      )}
      <Table.Tbody>
        {loading && (
          <Table.Tr>
            <Table.Td colSpan={headers?.length || 1} ta="center">
              <Stack>
                <Skeleton w="100%" h={60} />
                <Skeleton w="100%" h={60} />
                <Skeleton w="100%" h={60} />
                <Skeleton w="100%" h={60} />
                <Skeleton w="100%" h={60} />
              </Stack>
            </Table.Td>
          </Table.Tr>
        )}
        <AnimatePresence>
          {users.map((user) => (
            <UserContext.Provider value={user} key={user.id}>
              <motion.tr
                key={user.id}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                animate={{ opacity: 1, backgroundColor: "transparent" }}
                initial={{ opacity: 0, backgroundColor: "rgba(255,255,0,0.3)" }}
              >
                <Table.Td>
                  <UserLine user={user} isActive={user.is_active} url={withLink ? buildUserURL(user.id) : undefined} />
                </Table.Td>
                {children}
              </motion.tr>
            </UserContext.Provider>
          ))}
        </AnimatePresence>
      </Table.Tbody>
    </AppTable>
  )
  // biome-ignore-end lint/suspicious/noArrayIndexKey: reason
}
